import { ApolloQueryResult, useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';
import { notNil } from '@shared/util/notNil';
import { useCurrentBusinessId } from './useCurrentBusinessId';
import { useSeedInitialChannelUnreadCounts } from './useUnreadCount';

const HIDDEN_CHANNEL_TYPES: Array<API.ChannelType> = ['DM_SUPPORT', 'SUPPORT'];

interface ChannelListHook {
  channels: API.ChannelListItemFragment[];
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<API.ChannelListQuery>>;
}

export function useChannelList(): ChannelListHook {
  const businessId = useCurrentBusinessId();
  const { data, loading, refetch } = useQuery<API.ChannelListQuery>(Queries.channel.list, {
    skip: isNil(businessId),
  });
  useSeedInitialChannelUnreadCounts();

  return useMemo(
    () => ({
      channels: (data?.listChannels
        ?.filter(notNil)
        .filter(c => !HIDDEN_CHANNEL_TYPES.includes(c.type)) ??
        []) as API.ChannelListItemFragment[],
      loading,
      refetch,
    }),
    [data, loading, refetch],
  );
}
